import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'
import AboutContent from './AboutContent'


export default class About extends Component {

    render() {
        

        return (
            <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <AboutContent />
                <Footer />

            </div>


        )
    }
}
